import { render, staticRenderFns } from "./EquiposyPerifericosCrm.vue?vue&type=template&id=27a398c4&"
import script from "./EquiposyPerifericosCrm.vue?vue&type=script&lang=ts&"
export * from "./EquiposyPerifericosCrm.vue?vue&type=script&lang=ts&"
import style0 from "./EquiposyPerifericosCrm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports